/**
 * Успещный статус ответа
 *
 * @name constants.STATUS_CODE_OK
 * @type {number}
 */
export const STATUS_CODE_OK = 200;

/**
 * Структура данных по специальным предложениям
 * @name constants.promoIdsInfo
 */
// TODO: Убрать после получения данных для обработки СП от биллинга, сейчас в redux только id (WEB-34899)
export const promoIdsInfo: {[key: number]: Record<string, string>} = {
    1452: {
        monthsToPayDefault: '3 месяца',
        monthsToPayWithActivation: '4 месяца',
    },
    1454: {
        monthsToPayDefault: '6 месяцев',
        monthsToPayWithActivation: '7 месяцев',
    },
    27: {
        monthsToPayDefault: '3 месяца',
        monthsToPayWithActivation: '4 месяца',
    },
    26: {
        monthsToPayDefault: '6 месяцев',
        monthsToPayWithActivation: '7 месяцев',
    },
    25: {
        monthsToPayDefault: '3 месяца',
        monthsToPayWithActivation: '4 месяца',
    },
    24: {
        monthsToPayDefault: '6 месяцев',
        monthsToPayWithActivation: '7 месяцев',
    },
    1472: {
        monthsToPayDefault: '12 месяцев',
        monthsToPayWithActivation: '13 месяцев',
    },
    1501: {
        monthsToPayDefault: '12 месяцев',
        monthsToPayWithActivation: '13 месяцев',
    },
};

/**
 * Ответы для поп-апа при подключении/отключении СП
 * @name constants.connectViaActivation
 */
export enum connectViaActivation {
    'ACTIVATED' = 'Подключено',
    'DEACTIVATED' = 'Отключено',
    'OFFERS_ACTIVATING_QUICKLY' = 'Подарки и акции активируются сразу и будут доступны в зависимости от условий акции',
    'OFFERS_DEACTIVATING_QUICKLY' = 'Подарки и акции деактивируются сразу',
    'ERROR_ON_DEACTIVATE' = 'Ошибка при отключении',
    'ERROR_UNAVAILABLE' = 'Сейчас вы не можете подключить скидку',
    'TRY_AGAIN' = 'Перезагрузите страницу и попробуйте подключить еще раз',
}

/**
 * Список элементов маркированного списка в поп-апе неуспешного ответа
 * @name constants.causes
 */
export const causes = (monthsToPayString: string): Array<{id: number, text: string}> => [
    { id: 0, text: 'Ваш договор неактивен' },
    { id: 1, text: 'Услуга уже подключена' },
    { id: 2, text: `У вас на договоре недостаточно средств. Пополните счёт${monthsToPayString}` },
];
